import { Combobox, Input } from '@atlas/ui-primitives'
import { useMemo } from 'react'
import { DEFAULT_CURRENCY } from '@/domain/work-order.types'
import { currencyCodes } from '@/lib/money'

/** An amount as it is being typed, with its currency. */
export interface MoneyDraft {
	amount: string
	currency: string
}

export const EMPTY_MONEY_DRAFT: MoneyDraft = { amount: '', currency: DEFAULT_CURRENCY }

/**
 * An amount input beside a currency picker, `USD` until another is chosen. The amount is the
 * text as typed; parsing and validation belong to whoever submits it (`parseMoney`).
 */
export function MoneyField({
	label,
	value,
	onChange,
	isDisabled,
}: {
	label: string
	value: MoneyDraft
	onChange: (next: MoneyDraft) => void
	isDisabled?: boolean
}) {
	const currencies = useMemo(() => currencyCodes().map((code) => ({ value: code, label: code })), [])
	return (
		<div className="flex items-center gap-2">
			<Input
				aria-label={`${label} amount`}
				inputMode="decimal"
				value={value.amount}
				onChange={(e) => onChange({ ...value, amount: e.target.value })}
				placeholder="0.00"
				disabled={isDisabled}
				className="flex-1"
			/>
			<div className="w-28">
				<Combobox
					aria-label={`${label} currency`}
					options={currencies}
					value={value.currency}
					onChange={(code) => onChange({ ...value, currency: code ?? DEFAULT_CURRENCY })}
					isDisabled={isDisabled}
				/>
			</div>
		</div>
	)
}
